module.exports = "<button class=attachment-btn gmc-tooltip={{$ctrl.tooltip}} ngf-select=\"$ctrl.uploadFiles($files, $invalidFiles)\" ngf-pattern={{$ctrl.pattern}} ngf-max-size={{$ctrl.maxSize}} ngf-multiple=$ctrl.multiple accept={{$ctrl.accept}}>&plus;</button>";


//////////////////
// WEBPACK FOOTER
// ./app/components/attachment-upload-btn/attachment-upload-btn.component.html
// module id = 863
// module chunks = 31